// extracted by mini-css-extract-plugin
module.exports = {"resetButtonContainer":"FHIRSearchBox_resetButtonContainer_3xrj4"};